// import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

import ActionButton from "../ActionButton";
import ActionBox from "../ActionBox";

import styles from "./Sidebar.module.css";

//svg
import home_svg from "../../assets/svg/home.svg";
// import book_svg from "../../assets/svg/book.svg";
import data_svg from "../../assets/svg/data.svg";
import search_svg from "../../assets/svg/search.svg";
import graph_svg from "../../assets/svg/graph.svg";
import help_svg from "../../assets/svg/help.svg";
import logout_svg from "../../assets/svg/return-left.svg";
import FileActionBox from "./ActionBoxes.js/FileActionBox";
// import EditActionBox from "./ActionBoxes.js/EditActionBox";

import Box from "@mui/material/Box";
// import { FaTrash } from "react-icons/fa";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import SaveIcon from "@mui/icons-material/Save";
import DeleteIcon from "@mui/icons-material/Delete";
import Logo from "../../assets/png/logo.png";

const Sidebar = () => {
  const location = useLocation();
  // const [activeActions, setActiveActions] = useState("");

  const handleNavOptions = () => {
    if (location.pathname.split("/")[1] === "manage") {
      return (
        <>
          <NavLink to="manage/files">
            <ActionButton>
              <CloudUploadIcon fontSize="small" color="disabled" />
              <p>Your Files</p>
            </ActionButton>
          </NavLink>

          <NavLink to="manage/deleted">
            <ActionButton>
              <DeleteIcon color="disabled" />
              <p>Deleted Files</p>
            </ActionButton>
          </NavLink>
        </>
      );
    }

    return (
      <>
        <Box sx={{ position: "relative" }}>
          <ActionButton actionName={"file"}>
            <img src={home_svg} alt="Home" />
            <p>File</p>
          </ActionButton>
          <FileActionBox />
        </Box>

        <ActionButton actionName={"analysis"}>
          <ActionBox sx={{ left: "90%", top: "50%" }}>
            <ActionBox sx={{ left: "120%", top: "0px" }}>
              <Box>
                <p>1-Sample Zzzzzzzz</p>
                <p>1-Sample tttttttt</p>
                <p>2-Sample tttttttt</p>
                <p>Paired ttttttt</p>
              </Box>

              <Box>
                <p>1 Proportion</p>
                <p>2 Proportion</p>
                <p>1-Sample Poisson Rateeeeee</p>
                <p>2-Sample Poisson Rateeeeee</p>
                <p>Clear</p>
              </Box>

              <Box>
                <p>1 Variance</p>
                <p>2 Variances</p>
              </Box>

              <Box>
                <p>Correlation</p>
                <p>Covariance</p>
              </Box>

              <Box>
                <p>Normality Test</p>
                <p>Outlier Test</p>
              </Box>

              <Box>
                <p>Goodness-of-Fit Test</p>
              </Box>
            </ActionBox>

            <ActionBox sx={{ left: "120%", top: "0px" }}>
              <p>Option 1</p>
              <p>Option 2</p>
              <p>Option 3</p>
              <p>Option 4</p>
              <p>Option 5</p>
              <p>Option 6</p>
              <p>Option 7</p>
            </ActionBox>

            <ActionBox sx={{ left: "120%", top: "0px" }}>
              <p>Option 1</p>
              <p>Option 2</p>
              <p>Option 3</p>
              <p>Option 4</p>
              <p>Option 5</p>
              <p>Option 6</p>
              <p>Option 7</p>
            </ActionBox>

            <p>Basic Statistics</p>
            <p>Regression</p>
            <p>ANOVA</p>
            <p>DOE</p>
            <p>Control Charts</p>
            <p>Analysis 1</p>
            <p>Analysis 2</p>
            <p>Analysis 3</p>
          </ActionBox>
          <img src={search_svg} alt="Analysis" />
          <p>Analysis</p>
        </ActionButton>

        <ActionButton actionName={"graph"}>
          <ActionBox sx={{ left: "120%", top: "0px" }}>
            <p>Bar Graph</p>
            <p>Line Graph</p>
            <p>Pie Chart</p>
            <p>Scatter Plot</p>
          </ActionBox>
          <img src={graph_svg} alt="Graph" />
          <p>Graph</p>
        </ActionButton>

        <ActionButton actionName={"help"}>
          <ActionBox sx={{ left: "120%", top: "0px" }}>
            <p>Help</p>
            <p>Contact Us</p>
            <p>Keyboard Shortcuts</p>
            <p>About AskLex</p>
          </ActionBox>
          <img src={help_svg} alt="Help" />
          <p>Help</p>
        </ActionButton>
      </>
    );
  };

  return (
    <Box
      sx={{
        height: "100vh",
        width: "120px",
        position: "fixed",
      }}
    >
      <Box
        sx={{
          // width: "75px",
          margin: "auto",
          backgroundColor: "white",
          height: "100%",
          paddingTop: "2em",
          position: "relative",
          textAlign: "center",
        }}
      >
        <Link to="">
          <img src={Logo} alt="Alpha Tuos logo" className={styles.logo} />
        </Link>
        {handleNavOptions()}
        <Link to="" className={styles.exit}>
          <ActionButton>
            <img src={logout_svg} alt="Help" />
          </ActionButton>
        </Link>
      </Box>
    </Box>
  );
};

export default Sidebar;
